module.exports = __webpack_public_path__ + "static/media/P.23c20ce4.png";